import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './StartPage.css';

const StartPage = () => {
  const navigate = useNavigate();

  const handleStartClick = () => {
    navigate('/game');
  };

  return (
    <div className="start-page">
      <div className="start-background"></div>

      <div className="start-content">
        <motion.div
          className="start-title-container"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, delay: 0.5 }}
          onClick={handleStartClick}
        >
          <img src="assets/p1_start.png" alt="START" className="start-title" />
        </motion.div>
      </div>
    </div>
  );
};

export default StartPage;
